module.exports = __webpack_public_path__ + "img/profile_icon@2x.52d0d656.png";